import { asText, Content, isFilled } from '@prismicio/client';

// Services
import { retrieveIcon } from '@/services/utils/icons';

// Components
import {
  Box,
  Icon,
  AutoGrid,
  Headline,
  Typography,
  HeadlineHeading,
} from '@preventx/oxygen';

type WithIconsProps = {
  sliceId: string;
  slice: Content.RegionSliceWithIcons;
};

export const WithIcons = ({ sliceId, slice }: WithIconsProps) => {
  const { primary } = slice;
  const { title, caption, figures } = primary;

  return (
    <Box component="div" addSwitcher gap="gap-lg">
      <Headline addFlow>
        <HeadlineHeading component="h2">{asText(title)}</HeadlineHeading>

        {isFilled.richText(caption) && (
          <Typography component="p">{asText(caption)}</Typography>
        )}
      </Headline>

      <AutoGrid component="div">
        {(figures ?? []).map(({ caption, icon }, index) => {
          if (!icon) {
            return null;
          }

          const figureIcon = retrieveIcon(icon);

          return (
            <figure key={`region-end-to-end-${sliceId}-${index + 1}`}>
              <Icon icon={figureIcon} size="3x" />
              <figcaption>{asText(caption)}</figcaption>
            </figure>
          );
        })}
      </AutoGrid>
    </Box>
  );
};
